/* eslint-disable */
import React, {useState} from "react";
import {Image, Modal} from "react-bootstrap";
import contentPaste from "../../../static/icon/content_paste.svg";
import lightContentPaste from "../../../static/light-icon/content_paste.svg";
import "./index.css"
import {App, Avatar, Button, Divider, Form, Input} from "antd";
import {useTranslation} from "react-i18next";
import {
	getPhoneCode,
	getUserApi,
	setEmail,
	setGoogleEmail,
	setName,
	setPassword,
	setPhoneNumber,
	TriggerEmailApi,
	VerifyEmailApi
} from "../../../api/Api";
import {useGoogleLogin} from "@react-oauth/google";
import {md5} from "js-md5";
import {useAuth} from "../../../providers/AuthProvider";


function InfoPanel  ({
	show,
	setShow,
	isDarkMode,
	user,
	copyToClipboard,
	message,

}: any) {
	const handleClose = () => setShow(false);
	const {t, i18n} = useTranslation();
	const userdetail = useAuth();
	const getUserData = async () => {
		getUserApi()
			.then((res: object) => {
				localStorage.setItem("user", JSON.stringify(res));
				userdetail.setUserInfo(res);
			})
			.catch((e: Error) => {
				// toast.error("Failed to get user info");
				console.log(e.message);
			});
	};
	const handleUsernameSubmit = async (values: any) => {
		try {
			const res: any = await setName({
				userId: user?.userId,
				name: values.name,
			});
			if (res) {
				message.success("successful.");
				await getUserData();
				setShowUsernameModal(false);
			}
		} catch (e: any) {
			message.error(e);
		}
	};
	const handleEmailSubmit = async (values: any) => {
		try {
			const res: any = await VerifyEmailApi({
				email: values?.email,
				code: values?.code,
			});
			if (res) {
				const res2: any = await setEmail({
					userId: user?.userId,
					email: values?.email,
				});
				if (res2) {
					message.success("successful.");
					await getUserData();
					setShowEmailModal(false);
				}
			}
		} catch (e: any) {
			message.error(e);
		}
	};
	const handleGoogleSubmit = useGoogleLogin({
		flow: "auth-code",
		onSuccess: async (response) => {
			const res: any = await setGoogleEmail({
				userId: user?.userId,
				code: response.code,
			});
			if (res) {
				message.success("successful.");
				await getUserData();
			}
		},
		onError: () => {
			message.error("google login error");
		},
	});
	const handlePhoneNumberSubmit = async (values: any) => {
		try {
			const res: any = await setPhoneNumber({
				phoneNumber: values?.phoneNumber,
				userId: user?.userId,
			});
			if (res) {
				message.success("successful.");
				await getUserData();
				setShowPhoneNumberModal(false);
			}
		}  catch (e:any) {
			message.error(e?.message);
		}
	};
	const handlePasswordSubmit = async (values: any) => {
		try {
			const res = await setPassword({
				userId: user?.userId,
				password: md5(values?.password),
			});
			if (res) {
				message.success("successful.");
				await getUserData();
				setShowPasswordModal(false);
			}
		}  catch (e:any) {
			message.error(e);
		}
	};
	const [phoneForm] = Form.useForm();
	const [emailForm] = Form.useForm();
	const [phoneDisabled, setPhoneDisabled] = useState(false);
	const [phoneCountdown, setPhoneCountdown] = useState(60);
	const handleGetPhoneCode = async () => {
		const phoneNumber = phoneForm.getFieldValue("phoneNumber"); // 获取手机号
		if (!phoneNumber) {
			message.error("请输入手机号！");
			return;
		}
		setPhoneDisabled(true);
		let timeLeft = 60;
		const timer = setInterval(() => {
			timeLeft -= 1;
			setPhoneCountdown(timeLeft);
			if (timeLeft <= 0) {
				clearInterval(timer);
				setPhoneDisabled(false);
				setPhoneCountdown(60);
			}
		}, 1000);
		try {
			const res = await getPhoneCode({phoneNumber});
			if (res) {
				message.success("验证码已发送！");
			}
		} catch (e: any) {
			message.error("验证码发送失败，请稍后再试！");
			console.log(e);
			clearInterval(timer);
			setPhoneDisabled(false);
			setPhoneCountdown(60);
		}
	};
	const [emailDisabled, setEmailDisabled] = useState(false);
	const [emailCountdown, setEmailCountdown] = useState(60);
	const getEmailCode = async () => {
		const email = emailForm.getFieldValue("email"); // 获取手机号
		if (!email) {
			message.error("请输入email！");
			return;
		}
		setEmailDisabled(true);
		let timeLeft = 60;
		const timer = setInterval(() => {
			timeLeft -= 1;
			setEmailCountdown(timeLeft);
			if (timeLeft <= 0) {
				clearInterval(timer);
				setEmailDisabled(false);
				setEmailCountdown(60);
			}
		}, 1000);
		try {
			const res = await TriggerEmailApi({email});
			if (res) {
				message.success("验证码已发送！");
			}
		} catch (e: any) {
			message.error("验证码发送失败，请稍后再试！");
			console.log(e);
			clearInterval(timer);
			setEmailDisabled(false);
			setEmailCountdown(60);
		}
	};

	const [showUsernameModal, setShowUsernameModal] = useState(false);
	const [showEmailModal, setShowEmailModal] = useState(false);
	const [showPhoneNumberModal, setShowPhoneNumberModal] = useState(false);
	const [showPasswordModal, setShowPasswordModal] = useState(false);

	return (
		<>
			{/*修改密码*/}
			<Modal
				show={showPasswordModal}
				onHide={() => setShowPasswordModal(false)}
				centered
				className={`set-up-modal ${
					isDarkMode ? "dark-theme" : "light-theme"
				}`}
			>
				<Modal.Header closeButton>
					<Modal.Title>
						{i18n.language == "en" ? (
							<span>change password</span>
						) : (
							<span>修改密码</span>
						)}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form
						name="basic"
						layout="vertical"
						initialValues={{remember: true}}
						onFinish={handlePasswordSubmit}
						autoComplete="off"
					>
						<Form.Item
							label="密码"
							name="password"
							rules={[
								{required: true, message: "Please input your password!"},
							]}
							style={{marginBottom: "10px"}}
						>
							<Input.Password style={{height: "40px", width: "95%"}}/>
						</Form.Item>

						<Form.Item
							label={null}
							style={{textAlign: "center", marginTop: 30}}
						>
							<Button type="primary" htmlType="submit" className="submit-btn">
								确认
							</Button>
						</Form.Item>
					</Form>
				</Modal.Body>
			</Modal>

			{/*修改用户名*/}
			<Modal
				show={showUsernameModal}
				onHide={() => setShowUsernameModal(false)}
				centered
				className={`set-up-modal ${
					isDarkMode ? "dark-theme" : "light-theme"
				}`}
			>
				<Modal.Header closeButton>
					<Modal.Title>
						{i18n.language == "en" ? (
							<span>change password</span>
						) : (
							<span>修改用户名</span>
						)}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form
						name="basic"
						layout="vertical"
						initialValues={{remember: true}}
						onFinish={handleUsernameSubmit}
						autoComplete="off"
					>
						<Form.Item
							label="用户名"
							name="name"
							rules={[
								{required: true, message: "Please input your password!"},
							]}
							style={{marginBottom: "10px"}}
						>
							<Input style={{height: "40px", width: "95%"}}/>
						</Form.Item>

						<Form.Item
							label={null}
							style={{textAlign: "center", marginTop: 30}}
						>
							<Button type="primary" htmlType="submit" className="submit-btn">
								确认
							</Button>
						</Form.Item>
					</Form>
				</Modal.Body>
			</Modal>

			{/*修改邮箱*/}
			<Modal
				show={showEmailModal}
				onHide={() => setShowEmailModal(false)}
				centered
				className={`set-up-modal ${
					isDarkMode ? "dark-theme" : "light-theme"
				}`}
			>
				<Modal.Header closeButton>
					<Modal.Title style={{width: '100%', textAlign: 'center', paddingTop: '20px'}}>
						{i18n.language === 'en' ? (
							<span>change password</span>
						) : (
							<span>更换邮箱</span>
						)}
						<div style={{textAlign: "center", fontSize: "15px", color: "grey"}}>
							{user?.email}
						</div>
						<div style={{textAlign: "center", fontSize: "15px", color: "grey"}}>
							更换后将无法使用此邮箱登录此账号
						</div>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form
						name="basic"
						layout="vertical"
						initialValues={{remember: true}}
						onFinish={handleEmailSubmit}
						autoComplete="off"
						form={emailForm}
					>
						<Form.Item
							label="邮箱"
							name="email"
							rules={[
								{
									required: true,
									message: "Please input your phone number!",
								},
							]}
						>
							<Input style={{height: "40px", width: "95%"}}/>
						</Form.Item>

						<Form.Item label="验证码" required>
							<Input.Group compact>
								<Form.Item
									name="code"
									noStyle
									rules={[
										{required: true, message: "Please input your code!"},
									]}
								>
									<Input style={{height: "40px", width: "65%"}}/>
								</Form.Item>
								<Button
									type="primary"
									style={{height: "40px", width: "30%"}}
									onClick={getEmailCode}
									disabled={emailDisabled}
								>
									{emailDisabled ? `${emailCountdown}s` : "获取验证码"}
								</Button>
							</Input.Group>
						</Form.Item>

						<Form.Item
							label={null}
							style={{textAlign: "center", marginTop: 30}}
						>
							<Button type="primary" htmlType="submit" className="submit-btn">
								确认
							</Button>
						</Form.Item>
					</Form>
				</Modal.Body>
			</Modal>

			{/*修改手机号*/}
			<Modal
				show={showPhoneNumberModal}
				onHide={() => setShowPhoneNumberModal(false)}
				centered
				className={`set-up-modal ${
					isDarkMode ? "dark-theme" : "light-theme"
				}`}
			>
				<Modal.Header closeButton>
					<Modal.Title style={{width: '100%', textAlign: 'center', paddingTop: '20px'}}>
						{i18n.language === 'en' ? (
							<span>change password</span>
						) : (
							<span>更换手机号</span>
						)}
						<div style={{textAlign: "center", fontSize: "15px", color: "grey"}}>
							{user?.phoneNumber}
						</div>
						<div style={{textAlign: "center", fontSize: "15px", color: "grey"}}>
							更换后将无法使用此手机号登录此账号
						</div>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form
						form={phoneForm}
						name="basic"
						layout="vertical"
						initialValues={{remember: true}}
						onFinish={handlePhoneNumberSubmit}
						autoComplete="off"
					>
						<Form.Item
							label="手机号"
							name="phoneNumber"
							rules={[
								{
									required: true,
									message: "Please input your phone number!",
								},
							]}
						>
							<Input style={{height: "40px", width: "95%"}}/>
						</Form.Item>

						<Form.Item label="验证码" required>
							<Input.Group compact>
								<Form.Item
									name="code"
									noStyle
									rules={[
										{required: true, message: "Please input your code!"},
									]}
								>
									<Input style={{height: "40px", width: "65%"}}/>
								</Form.Item>
								<Button
									type="primary"
									style={{height: "40px", width: "30%"}}
									onClick={handleGetPhoneCode}
									disabled={phoneDisabled}
								>
									{phoneDisabled ? `${phoneCountdown}s` : "获取验证码"}
								</Button>
							</Input.Group>
						</Form.Item>

						<Form.Item
							label={null}
							style={{textAlign: "center", marginTop: 30}}
						>
							<Button type="primary" htmlType="submit" className="submit-btn">
								确认
							</Button>
						</Form.Item>
					</Form>
				</Modal.Body>
			</Modal>

			<Modal
				show={show}
				onHide={handleClose}
				centered
				className={`set-up-modal width-700-modal ${isDarkMode ? "dark-theme" : "light-theme"}`}
			>
				<Modal.Header closeButton>
					<Modal.Title>
						{i18n.language == "en" ? (
							<span>API Credentials</span>
						) : (
							<span>个人中心</span>
						)}
					</Modal.Title>
				</Modal.Header>
				<Divider style={{margin: '0 0'}}/>
				<Modal.Body>
					<div className="d-flex align-items-center">
						<Avatar
							style={{
								backgroundColor: "lightblue",
								paddingBottom: "10px",
								width: "54px",
								height: "54px",
								fontSize: "40px"
							}}
						>
							{user?.name?.[0]}
						</Avatar>
						<div style={{paddingLeft: "10px", paddingRight: "10px"}}>
							<div style={{fontSize: "20px"}}>{user?.name}</div>
							<div style={{fontSize: '14px', color: '#888'}}>{user?.email}</div>
						</div>
					</div>
					<Divider style={{margin: '15px 0'}}/>

					<div className="d-flex align-items-center mb-2" style={{width: "100%"}}>
						<div style={{width: "100px"}}>
							{i18n.language === "en" ? <span>USER ID</span> : <span>用户 ID</span>}
						</div>

						<div className="d-flex align-items-center justify-content-between flex-grow-1">
							<span>{user?.userId}</span>
							<Image
								style={{marginLeft: 8, cursor: "pointer"}}
								src={isDarkMode ? contentPaste : lightContentPaste}
								onClick={() => copyToClipboard(user?.userId)}
							/>
						</div>
					</div>
					<Divider style={{margin: '15px 0'}}/>
					<div className="d-flex align-items-center mb-2" style={{width: "100%"}}>
						<div style={{width: "100px"}}>
							{i18n.language === "en" ? <span>API key</span> : <span>API key</span>}
						</div>

						<div className="d-flex align-items-center justify-content-between flex-grow-1">
							<span>{user?.apiKey}</span>
							<Image
								style={{marginLeft: 8, cursor: "pointer"}}
								src={isDarkMode ? contentPaste : lightContentPaste}
								onClick={() => copyToClipboard(user?.userId)}
							/>
						</div>
					</div>
					<Divider style={{margin: '15px 0'}}/>

					<div className="d-flex align-items-center mb-2" style={{width: "100%"}}>
						<div style={{width: "100px"}}>
							{i18n.language === "en" ? <span>USER NAME</span> : <span>用户名</span>}
						</div>

						<div className="d-flex align-items-center justify-content-between flex-grow-1">
							<span>{user?.name}</span>
							<Button type="link" onClick={() => setShowUsernameModal(true)}>修改</Button>
						</div>
					</div>


					<Divider style={{margin: '15px 0'}}/>

					<div className="d-flex align-items-center mb-2" style={{width: "100%"}}>
						<div style={{width: "100px"}}>
							{i18n.language === "en" ? <span>EMAIL</span> : <span>邮箱</span>}
						</div>

						<div className="d-flex align-items-center justify-content-between flex-grow-1">
							<span>{user?.email}</span>
							<Button type="link" onClick={() => setShowEmailModal(true)}>修改</Button>
						</div>
					</div>

					<div className="d-flex align-items-center justify-content-between mb-2">
						{i18n.language == "en" ? (
							<>
								<span>GOOGLE: {user?.googleEmail}</span>
								<Button type="link" onClick={handleGoogleSubmit}>修改</Button>
							</>
						) : (
							<></>
						)}
					</div>
					<Divider style={{margin: '15px 0'}}/>
					<div className="d-flex align-items-center mb-2" style={{width: "100%"}}>
						<div style={{width: "100px"}}>
							{i18n.language === "en" ? <span>PHONE NUMBER</span> : <span>手机号</span>}
						</div>

						<div className="d-flex align-items-center justify-content-between flex-grow-1">
							<span>{user?.phoneNumber}</span>
							<Button type="link" onClick={() => setShowPhoneNumberModal(true)}>
								{i18n.language === "en"
									? user?.phoneNumber ? "change" : "bind"
									: user?.phoneNumber ? "更改" : "绑定"}
							</Button>
						</div>
					</div>

					<Divider style={{margin: '15px 0'}}/>
					<div className="d-flex align-items-center justify-content-between mb-2">
						<span></span>
						<Button type="link" onClick={() => setShowPasswordModal(true)}>
							{i18n.language == "en" ? "change password" : "修改密码"}
						</Button>
					</div>

				</Modal.Body>
				<Modal.Footer>
					<Button onClick={handleClose}>
						{i18n.language == "en" ? "Close" : "关闭"}
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	);
}

export default InfoPanel;
